<template>
    <div>
        <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">全国</el-checkbox>

        <div class="flex" v-for="(item, fatherindex) in cityobj.provinces" :key="fatherindex">

            <el-checkbox v-model="item.istrue" class="fatheritem" :indeterminate="item.isIndeterminate"
                @change="seconDhandleCheckAllChange(fatherindex, item.istrue)">{{ item.name }}</el-checkbox>

            <p class="itemCity" v-for="(city, childrenindex)  in item.cities" :key="city.code">
                <el-checkbox v-model="city.istrue" :label="city.name"
                    @change="threeHandleCheckAllChange(fatherindex, childrenindex, city.istrue)">{{ city.name }}</el-checkbox>
            </p>
        </div>
    </div>
</template>

<script>


export default {

    data() {
        return {
            checkAll: false,
            cityobj: { properties: [] },
            isIndeterminate: false
        };
    },
    methods: {
        init(v) {
            // 数据回显
            this.cityobj = v
            this.isIndeterminate = true
            if (this.cityobj.provinces.every(item => item.cities.every(item1 => item1.istrue))) {
                this.isIndeterminate = false
                this.checkAll = true
                this.$emit('allCountry', '0');
            }
            if (this.cityobj.provinces.every(item => item.cities.every(item1 => !item1.istrue))) {
                this.isIndeterminate = false
                this.checkAll = false;
                this.$emit('allCountry', '1');
            }

        },
        //一级change事件
        handleCheckAllChange(val) {
            console.log('一级change事件',val)
            console.log(2)
            this.cityobj.provinces.forEach(item => {
                item.istrue = val
                item.cities.forEach(item1 => {
                    item1.istrue = val
                })
            })
            this.isIndeterminate = false;
            this.checkAll = val;
            this.$emit('allCountry', val ? '0' : '1');
        },
        //二级change事件
        seconDhandleCheckAllChange(index, val) {

            this.isIndeterminate = false
            this.cityobj.provinces[index].isIndeterminate = false
            // this.cityobj.provinces.forEach(items => {
            //     items.cities.forEach(item => {
            //         item.istrue = items.istrue
            //     })
            // })
            // console.log(this.cityobj.provinces[index])
            let istrue = this.cityobj.provinces[index].istrue
            this.cityobj.provinces[index].cities.forEach(item => {
                item.istrue = istrue
            })
            // this.cityobj.provinces.forEach(items => {
            //     items.cities.forEach(item => {
            //         item.istrue = items.istrue
            //     })
            // })

            if (this.cityobj.provinces.every(item => item.istrue)) {
                this.checkAll = true
                this.$emit('allCountry', '0');
            } else {
                this.isIndeterminate = true
                this.checkAll = false;
                this.$emit('allCountry', '1');
            }
            // 二级都是fasle
            if (this.cityobj.provinces.every(item => !item.istrue)) {
                this.isIndeterminate = false
                this.checkAll = false
                this.$emit('allCountry', '1');
            }
        },

        //三级change事件
        threeHandleCheckAllChange(fatherindex, childrenindex, val) {
            console.log('三级change事件')
            this.isIndeterminate = false
            this.checkAll = false
            this.$emit('allCountry', '1');
            this.cityobj.provinces[fatherindex].isIndeterminate = false
            this.cityobj.provinces.forEach(items => {
                items.cities.forEach(item => {
                    if (item.istrue) {
                        // 如果有一项选中 一级二级添加不确定状态
                        this.isIndeterminate = true
                        items.isIndeterminate = true
                    }
                    if (items.cities.every(item1 => item1.istrue)) {
                        // 如果某一项所有选中去除不确定状态
                        items.isIndeterminate = false
                        items.istrue = true
                    }
                    if (items.cities.every(item1 => !item1.istrue)) {
                        //  如果某一项所有都不选中去除不确定状态
                        items.isIndeterminate = false
                        items.istrue = false
                    }
                })
            })
            if (this.cityobj.provinces.every(item => item.cities.every(item1 => item1.istrue))) {
                this.isIndeterminate = false
                this.checkAll = true
                this.$emit('allCountry', '0');
            }else {
                this.$emit('allCountry', '1'); 
            }

        },


    },

}
</script>

<style scoped lang="scss">
.flex {
    display: flex;
    flex-wrap: wrap;
    margin: 20px 0;
    // border-top:1px solid #ccc ;
    border-bottom: 1px solid #ccc;
    line-height: 40px;
}

.fatheritem {
    margin-right: 20px;
}

.itemCity {
    margin-right: 20px;

}
</style>